import { publications } from '@/data/publications';

/**
 * Витрина публикаций на /publications/.
 *
 * Набор обязан совпадать с архивом /category/publications/ на WordPress: после
 * катовера меню «Media & News Coverage» ведёт сюда, и то, чего нет на этой
 * странице, теряет единственную точку входа с сайта. Ссылки ведут на посты
 * WordPress — они остаются на месте (docs/URL-COVERAGE.md).
 */
const dateFmt = new Intl.DateTimeFormat('en-US', {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
  timeZone: 'UTC',
});

function formatDate(iso: string): string {
  return dateFmt.format(new Date(`${iso}T00:00:00Z`));
}

export default function PublicationsFeed() {
  return (
    <section className="py-14 lg:py-20 bg-white" aria-labelledby="publications-feed">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="section-label mb-6">Features &amp; News</div>
        <h2
          id="publications-feed"
          className="font-display text-navy text-3xl sm:text-4xl font-bold leading-tight mb-4"
        >
          Every Press Feature and Publication
        </h2>
        <p className="font-body text-navy/70 max-w-3xl mb-10">
          {publications.length} articles, broadcast interviews, and podcast episodes featuring the
          attorneys of Morgan Legal Group, newest first.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {publications.map((p) => (
            <a
              key={p.url}
              href={p.url}
              className="group flex flex-col bg-white border border-navy/10 hover:border-gold hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
            >
              <div className="relative overflow-hidden bg-cream" style={{ aspectRatio: '16 / 9' }}>
                <img
                  src={p.image}
                  alt={p.title}
                  loading="lazy"
                  decoding="async"
                  className="w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-105"
                />
                <span className="absolute top-3 right-3 bg-navy text-white font-body text-[0.6rem] tracking-[0.12em] uppercase px-3 py-1.5">
                  {p.category}
                </span>
              </div>
              <div className="flex flex-col flex-1 p-6">
                <h3 className="font-display text-navy text-lg font-bold leading-tight group-hover:text-gold transition-colors">
                  {p.title}
                </h3>
                <p className="font-body text-navy/60 text-sm mt-3 mb-5 flex-1">{p.excerpt}</p>
                <div className="flex items-center justify-between border-t border-navy/10 pt-4">
                  <span className="font-body text-gold text-xs tracking-[0.12em] uppercase">
                    Read More
                  </span>
                  <time className="font-body text-navy/50 text-xs" dateTime={p.date}>
                    {formatDate(p.date)}
                  </time>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
